<div class="flex flex-col h-screen bg-white">
    <app-contract-top-bar [view]="ContractTopBarView.COMPARE" [supportMenuItems]="supportMenuItems"
        [infoMenuItems]="infoMenuItems" [currentUser]="currentUser" style="z-index: 1000;"></app-contract-top-bar>
    @if(loading) {
    <div class="flex justify-center items-center  h-screen">
        <div class="loader"></div>
    </div>
    } @else {
    <!-- top bar -->
    <div class="flex justify-between items-end gap-2 p-2 border-b-2 border-gray-100">
        <div class="flex items-end gap-2">
            <div class="flex items-center gap-2">
                <i class="pi pi-angle-left cursor-pointer text-xl font-normal" (click)="goBack()"></i>
                <div class="flex flex-col justify-start">
                    <div class="flex justify-start items-center gap-1">
                        <div #editableContent scrollReset [attr.contenteditable]="editName"
                            [pTooltip]="editName ? undefined : comparisonInfo.name ?? ''" tooltipPosition="top"
                            class="text-xl max-w-[50rem] whitespace-nowrap overflow-x-auto inline-block no-scrollbar"
                            (keydown)="$event.key === 'Enter' ? blurSpan($event) : null"
                            (blur)="updateCompareName($event)">
                            {{comparisonInfo.name ?? ''}}
                        </div>
                        <i class="pi pi-pen-to-square cursor-pointer small-icon" (click)="enableEditing()"></i>
                    </div>
                    <div class="flex items-end gap-2">
                        <span class="text-xs text-gray-500">InnDoc AI Analysis Workspace</span>
                    </div>
                </div>
            </div>
            <app-popover #documentSelectionPanel (onHide)="onDocumentSelectionPanelClose()"
                (onToggle)="onDocumentSelectionPanelOpen()">
                <ng-template #trigger>
                    <div step-id="compare-step1"
                        class="inline-flex items-center justify-center gap-2 p-2 text-sm font-medium text-gray-700 border border-gray-200 bg-white rounded-base cursor-pointer transition-all duration-200 ease-in-out hover:bg-gray-100 active:bg-gray-200 select-none whitespace-nowrap">
                        <i class="pi pi-file-check"></i>
                        <span class="hidden sm:inline">{{ (documentsMapping | keyvalue).length }} Documents</span>
                    </div>
                </ng-template>
                <ng-template #body>

                    <div class="document-selection-panel flex flex-col gap-2">
                        <!-- Document Grid -->
                        <div class="flex flex-col gap-2 max-h-[60vh] overflow-y-auto custom-scroll">
                            <!-- Compare Documents -->
                            @for (item of tempDocumentsMapping | keyvalue:unsorted; track item.key) {
                            <div class="document-card" [class.selected]="item.value.consideredForComparison"
                                [class.disabled]="item.value.embeddingsStatus !== EMBEDDINGS_GENERATION_STATUS.COMPLETED">
                                <div class="flex items-center gap-3 w-full">
                                    <div class="flex justify-center align-center gap-3">
                                        <img src="/icons/home-card-icon.svg" alt="icon" class="icon">
                                    </div>
                                    <span [pTooltip]="item.value.name" tooltipPosition="top"
                                        class="truncate-2 w-full text-sm">
                                        {{ item.value.name }}
                                    </span>

                                    @if(item.value.embeddingsStatus === EMBEDDINGS_GENERATION_STATUS.IN_PROGRESS) {
                                    <div class="document-icon">
                                        <i class="pi pi-spin pi-spinner text-blue-500 text-lg"></i>
                                    </div>
                                    }
                                    @else if(item.value.embeddingsStatus === EMBEDDINGS_GENERATION_STATUS.FAILED) {
                                    <div class="flex items-center gap-3">
                                        <div class="document-icon">
                                            <i class="pi pi-exclamation-triangle text-danger text-lg"></i>
                                        </div>
                                    </div>
                                    }
                                    <div>
                                        <!-- <span class="text-xs">Document</span> -->
                                        <app-toggle [(ngModel)]="item.value.consideredForComparison"
                                            name="consideredForComparison_{{item.key}}"
                                            [disabled]="item.value.mainDocument || comparisonInfo.status?.kpis === COMPARE_DOCUMENT_STATUS.IN_PROGRESS ||comparisonInfo.status?.kpis === COMPARE_DOCUMENT_STATUS.PENDING"
                                            (onChange)="onTempDocumentSelectionChange()" />
                                    </div>
                                    <!-- <div>
                                                            <span class="text-xs">Linked</span>
                                                            <app-toggle [(ngModel)]="item.value.consideredWithLinkedDocs"
                                                                name="consideredWithLinkedDocs_{{item.key}}"
                                                                [disabled]="!item.value.consideredForComparison" />
                                                        </div> -->
                                </div>
                            </div>
                            }
                        </div>
                        <hr>
                    </div>
                </ng-template>
                <ng-template #footer>
                    <div class="flex justify-between my-1 items-center">
                        <span class="text-sm">{{ (tempDocumentsMapping | keyvalue| filter :
                            'value.consideredForComparison' : 'true')?.length ?? 0 }} / {{ (tempDocumentsMapping |
                            keyvalue)?.length
                            ??
                            0 }} Documents Considered</span>
                        <app-button label="Re-run Analysis" icon="pi pi-play" [disabled]="!canReRunAnalysis"
                            severity="primary"
                            (clicked)="confirmDocumentSelectionChanges(); documentSelectionPanel.hide()" />
                    </div>
                </ng-template>
            </app-popover>

            <app-button icon="pi pi-refresh" (clicked)="getComparison()" [enableThrottle]="true" variant="outlined"
                severity="contrast" [disabled]="loading" pTooltip="Refresh" tooltipPosition="top" />
        </div>
        <div class="flex items-end gap-2 h-full">
            <app-select [(value)]="selectedVersion" [options]="versionOptions" [config]="{ showClear: false }"
                (onChange)="compareVersionChange($event.value)" step-id="compare-step5">
            </app-select>
            <app-button label="Export" icon="pi pi-download" step-id="compare-step6" [loading]="downloadOverallLoading"
                [disabled]="downloadOverallLoading" severity="contrast" variant="outlined"
                (clicked)="downloadComparison({ showComplianceMatrix: true, showChart: true, showFullReport: true })"
                [enableThrottle]="true" />
        </div>
    </div>
    <!-- splitter -->
    <div class="relative w-full h-full">
        <!-- Right Panel Toggle Button -->
        <button *ngIf="!isRightGutterResizing" class="absolute panel-toggle-button"
            [style.left.%]="getRightButtonPosition()" [style.top]="'50%'" [style.transform]="'translate(-50%, -50%)'"
            [pTooltip]="rightPanelCollapsed ? 'Expand Documents' : 'Collapse Documents'" tooltipPosition="left"
            (click)="toggleRightPanel()">
            <i [class]="rightPanelCollapsed ? 'pi pi-chevron-left' : 'pi pi-chevron-right'"></i>
        </button>

        <!-- Two-panel splitter: center + right -->
        <p-splitter [style]="{ height: 'calc(100vh - 8.5rem)' }" [panelSizes]="getPanelSizes()"
            [minSizes]="getMinSizes()" (onResizeStart)="onResizeStart($event)" (onResize)="onPanelResizing($event)"
            (onResizeEnd)="onPanelResize($event)" layout="horizontal">
            <ng-template pTemplate>
                <ng-container *ngTemplateOutlet="centerPanelTemplate"></ng-container>
            </ng-template>
            <ng-template pTemplate>
                <ng-container *ngTemplateOutlet="rightPanelTemplate"></ng-container>
            </ng-template>
        </p-splitter>
    </div>

    @if (document && document._id && comparisonInfo._id) {
        <app-chat-bubble
            chatType="compare"
            [chatConfig]="{
                contractId: document._id,
                comparisonId: comparisonInfo._id,
                compareDocuments: compareDocumentList,
                kpiDocuments: kpiDocumentList,
                documentTypeId: documentTypeId,
                embeddingsStatus: areEmbeddingsReady ? EMBEDDINGS_GENERATION_STATUS.COMPLETED : EMBEDDINGS_GENERATION_STATUS.IN_PROGRESS
            }" />
    }
    }
</div>

<!-- Panel Templates -->
<ng-template #centerPanelTemplate>
    <div class="h-full w-full flex flex-col overflow-hidden" step-id="compare-step3">
        <div class="flex flex-col gap-1 border-b-2 border-gray-200 p-2 flex-shrink-0">
            <div class="flex items-center justify-between gap-2 flex-wrap">
                <div class="flex flex-col">
                    <span class="text-md font-bold">KPI Results</span>
                    <span class="text-xs font-extralight">{{ (documentsMapping | keyvalue)?.length ?? 0 }}
                        documents evaluated across {{ (kpiResult | keyvalue)?.length ?? 0 }} KPI(s)</span>
                </div>
                <div class="flex items-center gap-4">
                    <div class="border rounded-base flex items-center gap-2">
                        @for(reportView of reportViews; track $index) {
                        <i class="p-2 cursor-pointer" [class]="reportView.icon"
                            [ngClass]="{'bg-arena-blue-100': reportView.value === selectedReportView, 'text-arena-blue': reportView.value === selectedReportView}"
                            (click)="selectedReportView = reportView.value" [pTooltip]="reportView.label"
                            tooltipPosition="top"></i>
                        }
                    </div>

                </div>
            </div>
            <div class="flex justify-between flex-wrap items-center gap-2">
                <div class="flex flex-wrap items-center gap-2">
                    @for(checkpoint of kpiCheckpoints; track $index) {
                    <div class="flex items-center gap-2">
                        <i [class]="checkpoint.icon" class="text-xs" [ngClass]="checkpoint.iconColor"></i>
                        <span class="text-xs">{{checkpoint.label}}</span>
                    </div>
                    }
                </div>
                <app-button variant="outlined" severity="contrast" (clicked)="openAddKPIDialog()"
                    step-id="compare-step4" [label]="'Add KPI'" [icon]="'pi pi-plus'" />
            </div>
        </div>

        <div class="flex-1 overflow-y-auto custom-scroll p-2">
            <div class="flex flex-col gap-2">
                @if(kpiResult) {
                @for(kpi of kpiResult | keyvalue; track $index) {
                @if(kpi.value) {
                <p-accordion class="w-full border rounded-base group">
                    <p-accordion-panel value="0">
                        <p-accordion-header>
                            <ng-template #toggleicon let-active="active">
                                @if (active) {
                                <i class="pi pi-minus"></i>
                                } @else {
                                <i class="pi pi-plus"></i>
                                }
                            </ng-template>
                            <div class="flex w-full justify-between items-center gap-2">
                                <div class="flex flex-col flex-1 min-w-0">
                                    <span class="text-md font-bold truncate text-base"
                                        [class.animate-pulse]="kpi?.value?.kpiStatus === COMPARE_DOCUMENT_STATUS.IN_PROGRESS"
                                        [pTooltip]="kpi?.value?.kpiDoc?.name ?? ''" tooltipPosition="top"
                                        [style.max-width]="'85%'">
                                        {{kpi?.value?.kpiDoc?.name ?? ''}}
                                    </span>
                                </div>
                                @let kpiStatus = kpi?.value?.kpiStatus;
                                @let kpiId = kpi?.value?.kpiDoc?._id ?? '';
                                @let isCompleted = kpiStatus === COMPARE_DOCUMENT_STATUS.COMPLETED;
                                @let isError = kpiStatus === COMPARE_DOCUMENT_STATUS.ERROR;
                                @let isPaused = kpiStatus === COMPARE_DOCUMENT_STATUS.PAUSED;
                                @let isCreditsExhausted = isPaused && kpi?.value?.pauseReason === 'credits_exhausted';
                                @let isPending = kpiStatus === COMPARE_DOCUMENT_STATUS.PENDING;
                                @let isLinkedKpi = kpi?.value?.kpiDoc?.kpi_type === 'LINKED';
                                @let isInProgress = kpiStatus === COMPARE_DOCUMENT_STATUS.IN_PROGRESS;
                                @let showRetryAndAudit = isCompleted || isError || (isPaused && !isCreditsExhausted);

                                @if(isCompleted || isError || isPaused || isPending || isInProgress) {
                                <div
                                    class="flex items-center flex-wrap gap-3 mr-3 opacity-0 group-hover:opacity-100 transition-opacity duration-200">
                                    @if(isPending || isInProgress) {
                                    <i class="pi pi-stop-circle icon-sm cursor-pointer text-danger"
                                        (click)="$event.stopPropagation(); stopKpiGeneration(kpiId)"
                                        pTooltip="Stop KPI generation" tooltipPosition="top"></i>
                                    }
                                    @if(showRetryAndAudit) {
                                    <i class="pi pi-sync icon-sm cursor-pointer"
                                        (click)="$event.stopPropagation(); retryKpiGeneration(kpiId)"
                                        pTooltip="Retry KPI generation" tooltipPosition="top"></i>

                                    <i class="pi pi-shield icon-sm cursor-pointer"
                                        (click)="$event.stopPropagation(); getKpiAuditLogs(kpiId)"
                                        pTooltip="KPI Audit Logs" tooltipPosition="top"></i>
                                    }
                                    @if(isCompleted) {
                                    <i class="pi pi-download icon-sm cursor-pointer"
                                        [class.animate-pulse]="downloadKpiLoading == kpiId"
                                        (click)="$event.stopPropagation(); downloadComparison({ showComplianceMatrix: true, showChart: true, showFullReport: true }, kpiId)"
                                        pTooltip="Download KPI" tooltipPosition="top"></i>
                                    }
                                    @if(isLinkedKpi && !isInProgress) {
                                    <i class="pi pi-pencil icon-sm cursor-pointer"
                                        (click)="$event.stopPropagation(); editKpi(kpiId)" pTooltip="Edit KPI"
                                        tooltipPosition="top"></i>
                                    <i class="pi pi-trash icon-sm cursor-pointer text-danger"
                                        (click)="$event.stopPropagation(); confirmDeleteKpi(kpiId)"
                                        pTooltip="Delete KPI" tooltipPosition="top"></i>
                                    }
                                </div>
                                }
                            </div>
                        </p-accordion-header>
                        <p-accordion-content>
                            <div class="flex flex-col gap-4">
                                <div class="flex flex-col gap-0">
                                    <div class="kpi-description-container"
                                        [ngClass]="{'has-overflow': kpi?.value?.expanded}">
                                        <div class="prose prose-compact text-justify font-extralight text-xs prose-ul:pl-4 prose-ol:pl-4 prose-ul:ml-2 prose-ol:ml-2 w-full max-w-none"
                                            [innerHTML]="kpi?.value?.kpiDoc?.description ?? '' | truncate: (kpi?.value?.expanded ? 10000 : 150) | formatText"
                                            [ngClass]="{'max-h-60 overflow-y-auto pr-1': kpi?.value?.expanded}"
                                            style="line-height:1.5rem;" dynamicComponentRenderer>
                                        </div>
                                    </div>
                                    <div *ngIf="kpi?.value?.kpiDoc?.description && kpi.value.kpiDoc.description.length > 200"
                                        class="text-arena-orange cursor-pointer text-xs font-light"
                                        (click)="kpi.value.expanded = !kpi?.value?.expanded; $event.stopPropagation();">
                                        {{ kpi?.value?.expanded ? 'View Less' : 'View More' }}
                                    </div>
                                </div>
                                @if (kpi?.value?.kpiStatus === COMPARE_DOCUMENT_STATUS.PENDING) {
                                <div class="flex flex-col items-center gap-4 h-full w-full my-4">
                                    <app-documents-stack-loader class="w-full" width="full" size="compact"
                                        text="In Queue" [showText]="false" [showQueueInfo]="false">
                                        <div class="flex flex-col items-center gap-0">
                                            <span class="text-sm font-bold">In Processing Queue</span>
                                            <span class="text-xs font-extralight">
                                                Your KPI analysis has been added to the queue and will be
                                                processed shortly.
                                            </span>
                                        </div>
                                    </app-documents-stack-loader>
                                </div>
                                } @else if (kpi?.value?.kpiStatus === COMPARE_DOCUMENT_STATUS.IN_PROGRESS) {
                                <div class="flex flex-col items-center gap-4 w-full my-4">
                                    <app-documents-loader class="w-full" width="full" size="compact" text="Processing"
                                        [showText]="true">
                                    </app-documents-loader>
                                </div>
                                } @else if (kpi?.value?.kpiStatus === COMPARE_DOCUMENT_STATUS.COMPLETED) {
                                <!-- Report Content Section -->
                                <div class="flex flex-col gap-2">
                                    @if(selectedReportView === REPORT_VIEW.MATRIX) {
                                    <p-panel [toggleable]="true" toggler="header" [collapsed]="false" class="w-full">
                                        <ng-template pTemplate="header">
                                            <div class="flex flex-wrap items-center justify-between w-full gap-2 mr-2">
                                                <span class="text-sm font-bold">Compliance Matrix</span>
                                                <i class="pi pi-external-link cursor-pointer text-gray-600 hover:text-blue-600 text-sm"
                                                    (click)="openComplianceMatrixFullscreen($event, kpi)"
                                                    pTooltip="Open in fullscreen">
                                                </i>
                                            </div>
                                        </ng-template>
                                        <ng-template pTemplate="content">
                                            <ng-container *ngTemplateOutlet="complianceMatrixTableTemplate; context: { 
                                                                data: kpi?.value?.kpiData?.matrix ?? [], 
                                                                config: { paginator: false, rows: 10 },
                                                                tableClass: 'text-sm min-w-[45rem]'
                                                            }"></ng-container>
                                        </ng-template>
                                    </p-panel>
                                    }
                                    @if(selectedReportView === REPORT_VIEW.CHART) {
                                    <p-panel [toggleable]="true" toggler="header" [collapsed]="false" class="w-full">
                                        <ng-template pTemplate="header">
                                            <div class="flex flex-wrap items-center justify-between w-full gap-2 mr-2">
                                                <span class="text-sm font-bold">Chart</span>
                                                <i class="pi pi-external-link cursor-pointer text-gray-600 hover:text-blue-600 text-sm"
                                                    (click)="openChartFullscreen($event, kpi)"
                                                    pTooltip="Open in fullscreen">
                                                </i>
                                            </div>
                                        </ng-template>
                                        <ng-template pTemplate="content">
                                            <ng-container *ngTemplateOutlet="chartTemplate; context: { 
                                                            data: getProgressBarData(kpi?.value?.kpiData?.matrix ?? []),
                                                            isFullscreen: false
                                                        }"></ng-container>
                                        </ng-template>
                                    </p-panel>
                                    }
                                    @if(selectedReportView === REPORT_VIEW.FULL_REPORT) {
                                    <p-panel [toggleable]="true" toggler="header" [collapsed]="false" class="w-full">
                                        <ng-template pTemplate="header">
                                            <div class="flex flex-wrap items-center justify-between w-full gap-2 mr-2">
                                                <span class="text-sm font-bold">Full Report</span>
                                                <i class="pi pi-external-link cursor-pointer text-gray-600 hover:text-blue-600 icon-sm"
                                                    (click)="openFullReportFullscreen($event, kpi)"
                                                    pTooltip="Open in fullscreen">
                                                </i>
                                            </div>
                                        </ng-template>
                                        <ng-template pTemplate="content">
                                            <ng-container *ngTemplateOutlet="fullReportTemplate; context: { 
                                                            data: kpi?.value?.kpiData?.report ?? '',
                                                            isFullscreen: false
                                                        }"></ng-container>
                                        </ng-template>
                                    </p-panel>
                                    }
                                </div>

                                <!-- Evidence Sources Section -->
                                <p-panel [toggleable]="true" toggler="header" [collapsed]="true" class="w-full">
                                    <ng-template pTemplate="header">
                                        <div class="flex items-center gap-2 cursor-pointer">
                                            <span class="text-sm font-bold">Evidence Sources</span>
                                            <p-tag [value]="kpi?.value?.kpiData?.sources.length ?? 0" severity="info"
                                                class="rounded-base"></p-tag>
                                        </div>
                                    </ng-template>
                                    <ng-template pTemplate="content">
                                        <div class="flex flex-col gap-2">
                                            @for(source of kpi?.value?.kpiData?.sources; track $index) {
                                            <div class="flex flex-col gap-2 p-2 border rounded-base cursor-pointer"
                                                [ngClass]="{'bg-arena-orange-100': selectedDocument?._id === source.source && selectedDocument?.pageNumber === source.page_number}"
                                                (click)="selectDocument(documentsMapping[source.source], source.page_number)">
                                                @if(documentsMapping[source.source] &&
                                                documentsMapping[source.source].name){
                                                <span
                                                    class="text-xs font-semibold">{{documentsMapping[source.source].name}}</span>
                                                <span class="text-xs font-light">Page
                                                    Number:{{source.page_number}}</span>
                                                }
                                            </div>
                                            }
                                        </div>
                                    </ng-template>
                                </p-panel>
                                } @else if (kpi?.value?.kpiStatus === COMPARE_DOCUMENT_STATUS.PAUSED && kpi?.value?.pauseReason === 'credits_exhausted') {
                                <!-- Credits-exhausted state: reuse the same credits-overview card as the summary panel -->
                                <div class="p-2 my-2">
                                    <app-credits-overview
                                        variant="exhaustioncard"
                                        feature="COMPARE"
                                        mode="agent"
                                        [featureId]="comparisonInfo._id ?? ''"
                                        [externalResume]="true"
                                        (resume)="resumeKpiGeneration(kpi?.value?.kpiDoc?._id ?? '')"
                                    />
                                </div>
                                } @else if (kpi?.value?.kpiStatus === COMPARE_DOCUMENT_STATUS.ERROR) {
                                <div class="flex flex-col items-center h-full w-full p-2 my-4">
                                    <app-documents-error-loader class="w-full" width="full" size="compact"
                                        [showText]="false">
                                        <div class="flex gap-0 flex-col items-center justify-center h-full">
                                            <span class="text-sm font-semibold text-danger">Failed to
                                                generate report</span>
                                            <span class="text-danger text-center text-xs">
                                                An unexpected error occurred while processing your request.
                                            </span>
                                            <app-button (clicked)="retryKpiGeneration(kpi?.value?.kpiDoc?._id ?? '')"
                                                [enableThrottle]="true" icon="pi pi-refresh" label="Retry"
                                                severity="danger" variant="outlined" type="submit" />
                                        </div>
                                    </app-documents-error-loader>
                                </div>
                                } @else if (kpi?.value?.kpiStatus === COMPARE_DOCUMENT_STATUS.NO_INSIGHTS) {
                                <div class="flex flex-col items-center h-full w-full p-2 my-4">
                                    <app-documents-error-loader class="w-full" width="full" size="compact"
                                        [showText]="false">
                                        <div class="flex gap-0 flex-col items-center justify-center h-full">
                                            <span class="text-sm font-semibold text-danger">Failed to
                                                generate report</span>
                                            <span class="text-danger text-center text-xs">
                                                At least two documents with insights are required to perform a
                                                comparison
                                            </span>
                                            <app-button (clicked)="retryKpiGeneration(kpi?.value?.kpiDoc?._id ?? '')"
                                                [enableThrottle]="true" icon="pi pi-refresh" label="Retry"
                                                severity="danger" variant="outlined" type="submit" />
                                        </div>
                                    </app-documents-error-loader>
                                </div>
                                }
                            </div>
                        </p-accordion-content>
                    </p-accordion-panel>
                </p-accordion>
                }
                }
                }
            </div>
        </div>

    </div>
</ng-template>

<ng-template #rightPanelTemplate>
    <div class="h-full w-full flex-1" [ngClass]="{'p-1': rightPanelCollapsed}">
        <!-- Overlay to capture events during resize -->
        @if(isRightGutterResizing) {
        <div class="absolute inset-0 z-50 cursor-col-resize" style="pointer-events: all;"></div>
        }
        @if(!rightPanelCollapsed) {
        <!-- Expanded Documents Panel using app-tabs-panels -->
        <app-tabs-panels #tabsPanels [tabs]="tabsConfig" [activeTabValue]="activeTabValue" [scrollable]="true"
            [customClass]="'h-full flex flex-col overflow-hidden'" [tabListClass]="'document-tabs border-b'"
            [tabPanelsClass]="'flex-1 overflow-hidden bg-white'" (tabChanged)="onTabChanged($event)"
            class="h-full flex flex-col">
        </app-tabs-panels>
        } @else {
        <!-- Collapsed Documents Panel - Minimal View -->
        <div class="h-full flex flex-col items-center justify-start pt-4">
            <div class="writing-mode-vertical text-sm font-bold text-gray-600 transform rotate-180">
                Documents
            </div>
            <div class="mt-4">
                <i class="pi pi-file text-2xl text-gray-400"></i>
            </div>
        </div>
        }
    </div>
</ng-template>

<ng-template #documentsTemplate>
    <div class="flex flex-col h-full relative w-full">
        <!-- Document Selection Panel -->
        <div class="absolute top-2 left-2 shadow-lg z-10">
            <app-popover #documentSelectionPanel [showScrollbar]="true" [width]="'25rem'" [maxHeight]="'25rem'">
                <ng-template #trigger>
                    <app-button #checkListButtonRef icon="pi pi-list" severity="contrast" variant="outlined" />
                </ng-template>
                <ng-template #body>
                    <div class="flex flex-col gap-2 h-full">
                        <div class="flex flex-col gap-2 sticky top-0 z-10 bg-white pb-2">
                            <app-search-bar placeholder="Search" class="w-full" [(ngModel)]="searchDocument"
                                name="searchDocument" (searchChange)="onSearchDocument($event)"></app-search-bar>
                        </div>

                        <div class="flex flex-col gap-2 flex-1 overflow-y-auto custom-scroll pr-3">
                            <!-- Compare Documents -->
                            @for(doc of (documentsMapping | keyvalue | filter : 'value.name' : searchDocument);
                            track
                            $index) {
                            @if(doc.value) {
                            <div class="flex flex-col gap-2 border-l-4 border rounded-base p-2 pr-3 transition-all cursor-pointer border-gray-200"
                                [class.border-l-arena-blue]="selectedDocument?._id === doc.value._id"
                                (click)="selectDocument(doc.value); documentSelectionPanel.hide()">
                                <div class="flex items-start justify-between">
                                    <span class="text-sm font-semibold"
                                        [pTooltip]="doc.value.name.length > 50 ? doc.value.name : undefined"
                                        tooltipPosition="top">
                                        {{doc.value.name.length > 50 ? doc.value.name.substring(0, 50) + '...' :
                                        doc.value.name}}</span>
                                    <div class="flex items-center gap-2">
                                        <i class="pi pi-file text-xl"></i>
                                    </div>
                                </div>
                                @if(doc.value.linkedDocTypeName) {
                                <div class="flex items-center gap-4 text-sm">
                                    <span
                                        class="px-2 py-1 rounded text-xs font-medium bg-gray-100 w-1/3 text-center text-wrap">{{doc.value.linkedDocTypeName}}</span>
                                </div>
                                }
                            </div>
                            }
                            }
                        </div>
                    </div>
                </ng-template>
            </app-popover>
        </div>

        <div class="flex-1 overflow-hidden h-full">
            @if(selectedDocument && selectedDocument.attachment && selectedDocument.attachment.fullUrl ) {
            <div class="h-full w-full">
                @if(isPdfDocument(selectedDocument) && selectedDocument.pageNumber) {
                <!-- Use simple PDF viewer for PDF documents -->
                <div class="h-full w-full" [attr.data-pdf-key]="getDocumentTrackKey(selectedDocument)">
                    <app-pdf-viewer class="h-full w-full" [pdfUrl]="selectedDocument.attachment.fullUrl"
                        [initialPage]="selectedDocument.pageNumber" [title]="selectedDocument.name"
                        [hideToolbar]="true">
                    </app-pdf-viewer>
                </div>
                } @else {
                <!-- Use OnlyOffice document preview for other document types -->
                <app-document-preview class="h-full w-full" [documentId]="selectedDocument._id"
                    [file]="selectedDocument.attachment">
                </app-document-preview>
                }
            </div>
            } @else {
            <div class="h-full w-full flex items-center justify-center bg-gray-50">
                <div class="text-center">
                    <p class="text-gray-600">No document selected</p>
                </div>
            </div>
            }
        </div>
    </div>

</ng-template>

<ng-template #reportTemplate>
    <div class="flex flex-col gap-2 border-2 border-gray-200 rounded-base p-3">
        <div class="flex items-center justify-between">
            <div class="flex items-center">
                <i class="pi pi-chart-line mr-2"></i>
                <span class="text-sm font-bold">Executive Summary</span>
            </div>
            <div class="flex items-center gap-1">
                <app-button
                    (clicked)="downloadComparison({ showComplianceMatrix: false, showChart: false, showFullReport: true }, '', 'preview')"
                    [enableThrottle]="true" [loading]="downloadReportLoading === 'preview'"
                    [disabled]="downloadReportLoading === 'preview'" icon="pi pi-eye" severity="contrast" type="submit"
                    toolTip="Preview" tooltipPosition="bottom" />
                <app-button
                    (clicked)="downloadComparison({ showComplianceMatrix: false, showChart: false, showFullReport: true })"
                    [enableThrottle]="true" [loading]="downloadReportLoading === 'download'"
                    [disabled]="downloadReportLoading === 'download'" icon="pi pi-download" severity="contrast"
                    type="submit" toolTip="Download" tooltipPosition="bottom" />
                <app-button
                    (clicked)="downloadComparison({ showComplianceMatrix: false, showChart: false, showFullReport: true }, '', 'open')"
                    [enableThrottle]="true" [loading]="downloadReportLoading === 'open'"
                    [disabled]="downloadReportLoading === 'open'" icon="pi pi-external-link" severity="contrast"
                    type="submit" toolTip="Open" tooltipPosition="bottom" />
            </div>
        </div>
        <div class="flex flex-col gap-1">
            <span class="text-sm">High-level analysis results and recommendations</span>
            <span class="text-xs font-light">Formats Available: PDF</span>
        </div>
    </div>
    <div class="flex flex-col gap-2 border-2 border-gray-200 rounded-base p-3">
        <div class="flex items-center justify-between">
            <div class="flex items-center">
                <i class="pi pi-table mr-2"></i>
                <span class="text-sm font-bold">Compliance Matrix</span>
            </div>
            <div class="flex items-center">
                <app-button
                    (clicked)="downloadComparison({ showComplianceMatrix: true, showChart: false, showFullReport: false }, '', 'preview')"
                    [enableThrottle]="true" [loading]="downloadMatrixLoading === 'preview'"
                    [disabled]="downloadMatrixLoading === 'preview'" icon="pi pi-eye" severity="contrast" type="submit"
                    toolTip="Preview" tooltipPosition="bottom" />
                <app-button
                    (clicked)="downloadComparison({ showComplianceMatrix: true, showChart: false, showFullReport: false })"
                    [enableThrottle]="true" [loading]="downloadMatrixLoading === 'download'"
                    [disabled]="downloadMatrixLoading === 'download'" icon="pi pi-download" severity="contrast"
                    type="submit" toolTip="Download" tooltipPosition="bottom" />
                <app-button
                    (clicked)="downloadComparison({ showComplianceMatrix: true, showChart: false, showFullReport: false }, '', 'open')"
                    [enableThrottle]="true" [loading]="downloadMatrixLoading === 'open'"
                    [disabled]="downloadMatrixLoading === 'open'" icon="pi pi-external-link" severity="contrast"
                    type="submit" toolTip="Open" tooltipPosition="bottom" />
            </div>
        </div>
        <div class="flex flex-col gap-1">
            <span class="text-sm">Detailed KPI scoring with evidence mapping</span>
            <span class="text-xs font-light">Formats Available: PDF</span>
        </div>
    </div>
    <div class="flex flex-col gap-2 border-2 border-gray-200 rounded-base p-3">
        <div class="flex items-center justify-between">
            <div class="flex items-center">
                <i class="pi pi-history mr-2"></i>
                <span class="text-sm font-bold">Audit Logs</span>
            </div>
            <app-button icon="pi pi-download" severity="contrast" (clicked)="showAuditsExportDialog = true"
                toolTip="Export Audit Logs" tooltipPosition="top" />
        </div>
        <div class="flex flex-col gap-1">
            <span class="text-sm">Detailed event history for monitoring and review</span>
            <span class="text-xs font-light">Formats Available: PDF/Excel</span>
        </div>
    </div>
</ng-template>

<ng-template #auditLogsTemplate>
    <div class="inn-flex-container flex flex-col gap-2 p-2 h-full overflow-auto">
        <div class="flex justify-between items-center">
            <div class="flex items-center gap-4">
                <h2 class="text-sm font-semibold">Audit Logs</h2>
                <app-button icon="pi pi-refresh" (clicked)="getAuditLogs(true)" [enableThrottle]="true"
                    variant="outlined" severity="contrast" [disabled]="loading || loadingAuditLogs"
                    [class]="loadingAuditLogs ? 'refresh-loading' : ''" toolTip="Refresh Audit Logs"
                    tooltipPosition="top" />
            </div>
            @if(showExport){
            <div class="flex items-center">
                <app-button icon="pi pi-download" variant="outlined" severity="contrast"
                    (clicked)="showAuditsExportDialog = true" toolTip="Export Audit Logs" tooltipPosition="top" />
            </div>
            }
        </div>

        <ng-container *ngTemplateOutlet="auditLogsCardsTemplate; context: { data: auditLogs }"></ng-container>

    </div>

</ng-template>

<app-dialog [(visible)]="showAuditsExportDialog" title="Export Audit Logs" (closed)="showAuditsExportDialog = false"
    class="max-w-[25rem]" [fullscreenOnMobile]="true">
    <ng-template #bodyTemplate>
        <div class="flex flex-col gap-4 p-4">
            <p class="text-sm text-gray-600">Choose export format:</p>
            <div class="flex flex-col gap-3">
                <app-button label="Export as Excel" icon="pi pi-file-excel" variant="outlined" severity="secondary"
                    (clicked)="exportAuditsToExcel()" [enableThrottle]="true" />
                <app-button label="Export as PDF" icon="pi pi-file-pdf" variant="outlined" severity="secondary"
                    (clicked)="exportAuditsToPDF()" [enableThrottle]="true" />
            </div>
        </div>
    </ng-template>
</app-dialog>

<!-- Data Table Templates -->
<!-- Evidence Template -->
<ng-template #evidenceTemplateRef let-rowData="$implicit">
    <span class="text-sm text-gray-800">
        {{rowData?.sources?.length ?? (rowData?.evidence?.length ?? 0)}}
    </span>
</ng-template>

<!-- Summary Template -->
<ng-template #summaryTemplateRef let-rowData="$implicit">
    <div class="line-clamp-2" [pTooltip]="rowData?.summary" tooltipPosition="top" [escape]="false">
        {{rowData?.summary || ''}}
    </div>
</ng-template>

<!-- Reusable Compliance Matrix Table Template -->
<ng-template #complianceMatrixTableTemplate let-data="data" let-config="config" let-tableClass="tableClass"
    let-isFullscreen="isFullscreen">
    <div class="overflow-x-auto">
        <app-data-table [data]="data" [columns]="[
                {field: 'entity', header: 'Entity', width: isFullscreen ? '12rem' : '10rem'},
                {field: 'status', header: 'Status', width: isFullscreen ? '8rem' : '5rem', type: 'badge'},
                {field: 'score', header: 'Score', width: isFullscreen ? '8rem' : '5rem'},
                {field: 'confidence', header: 'Confidence', width: isFullscreen ? '8rem' : '5rem'},
                {field: 'traceability', header: 'Traceability', width: isFullscreen ? '8rem' : '5rem'},
                {field: 'summary', header: 'Summary', width: isFullscreen ? '20rem' : '15rem', type: 'custom', template: 'summaryTemplate'}
            ]" [config]="config" [tableClass]="tableClass + (isFullscreen ? '' : ' min-w-[45rem]')"
            [dataKey]="'entity'" [customTemplates]="templatesMap">
        </app-data-table>
    </div>
</ng-template>

<app-dialog [(visible)]="kpiDialog.visible" [title]="kpiDialog.mode + ' KPI'" (closed)="onKPIDialogClose()"
    class="max-w-[60vw] h-[60vh]" [fullscreenOnMobile]="true">
    <ng-template #bodyTemplate>
        <div class="flex flex-col gap-4 p-4">
            <div class="flex flex-col gap-1">
                <label for="name">Name <span class="text-danger">*</span></label>
                <input pInputText id="name" name="kpiName" class="flex-auto border rounded-base input p-1"
                    autocomplete="off" [(ngModel)]="kpiDialogForm.name" required />
            </div>
            <div class="flex flex-col gap-1">
                <label for="description">Description <span class="text-danger">*</span></label>
                <textarea pInputTextarea id="description" name="kpiDescription"
                    class="flex-auto border rounded-base input p-1" rows="9" autocomplete="off"
                    [(ngModel)]="kpiDialogForm.description"></textarea>
            </div>
        </div>
    </ng-template>
    <ng-template #footerTemplate>
        <div class="flex justify-end">
            <app-button label="Save" severity="primary" icon="pi pi-save" (clicked)="saveKpi()"
                [enableThrottle]="true" />
        </div>
    </ng-template>
</app-dialog>

<!-- Unified Fullscreen Dialog -->
<app-dialog [(visible)]="fullscreenDialog.visible" [title]="fullscreenDialog.title" (closed)="closeFullscreenDialog()"
    class="max-w-[90vw] h-[90vh]" [fullscreenOnMobile]="true">
    <ng-template #bodyTemplate>
        <div class="h-full overflow-auto" [class.p-4]="fullscreenDialog.type === FullscreenDialogType.FULL_REPORT">
            @switch (fullscreenDialog.type) {
            @case (FullscreenDialogType.COMPLIANCE_MATRIX) {
            <ng-container *ngTemplateOutlet="complianceMatrixTableTemplate; context: { 
                        data: currentKpiForDialog?.value?.kpiData?.matrix ?? [], 
                        config: { paginator: true, rows: 25 },
                        tableClass: 'text-sm',
                        isFullscreen: true
                    }"></ng-container>
            }
            @case (FullscreenDialogType.CHART) {
            <ng-container *ngTemplateOutlet="chartTemplate; context: { 
                        data: getProgressBarData(currentKpiForDialog?.value?.kpiData?.matrix ?? []),
                        isFullscreen: true
                    }"></ng-container>
            }
            @case (FullscreenDialogType.FULL_REPORT) {
            <ng-container *ngTemplateOutlet="fullReportTemplate; context: { 
                        data: currentKpiForDialog?.value?.kpiData?.report ?? '',
                        isFullscreen: true
                    }"></ng-container>
            }
            }
        </div>
    </ng-template>
</app-dialog>

<!-- Reusable Chart Template -->
<ng-template #chartTemplate let-data="data" let-isFullscreen="isFullscreen">
    @if(data && data.length > 0) {
    <div class="flex flex-col gap-4 p-4">
        @for(item of data; track $index) {
        <div class="flex flex-col gap-2">
            <div class="flex items-center w-full gap-4">
                <div class="flex items-center gap-2" style="width: 25%;">
                    <span class="text-sm font-semibold cursor-help break-words" [pTooltip]="item.entity"
                        tooltipPosition="top">
                        {{item.entity}}
                    </span>
                </div>
                <div class="flex-1">
                    <p-progressBar [value]="item.score" [showValue]="true" [class]="'h-3 progress-' + item.severity">
                    </p-progressBar>
                </div>
            </div>
        </div>
        }
    </div>
    } @else {
    <div class="flex items-center justify-center h-32 text-gray-500">
        <span class="text-sm font-extralight">No chart data available</span>
    </div>
    }
</ng-template>

<!-- Reusable Full Report Template -->
<ng-template #fullReportTemplate let-data="data" let-isFullscreen="isFullscreen">
    <div class="prose prose-compact text-justify font-extralight prose-ul:pl-1 prose-ol:pl-2 2xl:prose-ul:pl-4 2xl:prose-ol:pl-3 sm:prose-ul:pl-3"
        [class]="isFullscreen ? 'text-base max-w-none' : 'text-xs'" [innerHTML]="data | formatText"
        dynamicComponentRenderer [style.line-height]="isFullscreen ? '1.7rem' : '1.5rem'">
    </div>
</ng-template>


<app-delete-confirmation [(visible)]="showKpiDeleteDialog" headerText="Are you sure?"
    bodyText="Are you sure you want to delete this KPI?" confirmButtonText="Delete" (onConfirm)="deleteKpi()">
</app-delete-confirmation>


<app-dialog [(visible)]="showReportPreview" [title]="previewTitle" (closed)="closeReportPreview()"
    class="max-w-[60vw] h-[90vh]" [fullscreenOnMobile]="true">
    <ng-template #bodyTemplate>
        <div class="h-full w-full">
            <app-pdf-viewer class="h-full w-full" [pdfUrl]="reportUrl" [title]="previewTitle" [hideToolbar]="true">
            </app-pdf-viewer>
        </div>
    </ng-template>
</app-dialog>

<app-dialog [(visible)]="showKpiAuditLogsDialog" [showCloseButton]="false" (closed)="closeKpiAuditLogsDialog()"
    class="max-w-[50vw] h-[80vh]" [fullscreenOnMobile]="true">
    <ng-template #headerTemplate>
        <div class="flex flex-col w-full gap-1 px-6 pt-4">
            <div class="text-base font-bold">Audit Trail</div>
            <div class="text-base text-gray-500">{{kpiDialogForm.name}}</div>
            <div class="flex items-center gap-2">
                <p-tag icon="pi pi-wave-pulse" value="Full Audit Trail" severity="info"
                    class="rounded-base px-1.5"></p-tag>
                <p-tag icon="pi pi-users" value="Governance Enabled" severity="success"
                    class="rounded-base px-1.5"></p-tag>
            </div>
            <hr class="mt-2">
        </div>
    </ng-template>
    <ng-template #bodyTemplate>
        <ng-container *ngTemplateOutlet="auditLogsCardsTemplate; context: { data: kpiAuditLogs }"></ng-container>
    </ng-template>
    <ng-template #footerTemplate>
        <div class="flex items-center justify-end gap-3">
            <app-button label="Close" severity="secondary" icon="pi pi-times" (clicked)="closeKpiAuditLogsDialog()" />
            <app-button label="Export Audit Logs" icon="pi pi-download" [disabled]="!kpiAuditLogs.length"
                severity="primary" (clicked)="showAuditsExportDialog = true" />
        </div>
    </ng-template>
</app-dialog>

<ng-template #auditLogsCardsTemplate let-data="data">
    @if (data.length > 0) {
    <div class="flex flex-col gap-2">
        @for (audit of data; track audit) {
        <div
            class="flex flex-col p-4 border border-gray-200 rounded-base shadow-sm hover:shadow-md transition-shadow duration-200 bg-white gap-2">
            <div class="flex items-start justify-between">
                <div class="flex-1">
                    <div class="text-base text-gray-800 font-medium">{{ audit.action }}</div>
                    <div class="text-sm text-gray-500 mt-1">{{ audit.description }}</div>

                    <div class="text-xs text-gray-400 mt-2">
                        Status: <span class="font-medium" [ngClass]="{
                          'text-success': audit.status === 'SUCCESS',
                          'text-danger': audit.status === 'FAILED',
                          'text-yellow-500': audit.status === 'PENDING'
                        }">{{ audit.status }}</span>
                        · {{ audit.createdAt | date: 'medium' }}
                    </div>
                </div>
            </div>
            <div class="flex gap-2 items-center">
                <span class="text-sm text-gray-800">Created By</span>
                <div class="flex gap-1 items-center">
                    <app-user-name-display [user]="audit.createdBy" [variant]="'avatar-name'"></app-user-name-display>
                </div>
            </div>
        </div>
        }
    </div>
    } @else {
    <div class="flex flex-col justify-center items-center h-full text-center py-8">
        <p class="text-gray-400 text-sm">No audit logs available.</p>
    </div>
    }
</ng-template>


<app-dialog [visible]="supportTicketDialog" [title]="'Raise a Support Ticket' | textCase"
[fullscreenOnMobile]="true" class="max-w-[40rem] h-[41rem]" (closed)="onSupportTicketDialogHide()">
<ng-template #bodyTemplate>
    <div class="px-6 py-4 h-full overflow-y-auto">
        <app-support-ticket-form #supportTicketForm [isDialog]="true"
            (ticketSubmitted)="onSupportTicketSubmitted()">
        </app-support-ticket-form>
    </div>
</ng-template>
</app-dialog>

<app-capture-issue #captureIssue (captureCompleted)="onCaptureCompleted($event)"></app-capture-issue>
